import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-plus-icon',
  templateUrl: './navigation-plus.component.html'
})
export class NavigationPlusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
